import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const postAnnotation = ({ snapshotId, location, creatorGuid }) => {
  const annotationAttributes = {
    data: {
      type: 'annotation',
      attributes: {
        location,
      },
      creator_guid: creatorGuid,
    },
    params: {
      include: 'user,user.avatar_asset_reference',
    },
  }

  return HttpClient().post(
    `/annotations/v1/${snapshotId}`,
    annotationAttributes
  )
}

const createAnnotation = (options) => (dispatch) =>
  postAnnotation(options)
    .then((response) => {
      const body = response.data
      if (body.data) dispatch(loadJsonApiEntities(body))

      return body.data
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default createAnnotation
